import { createSignal, For, Show } from "solid-js";
import { useStateContext } from '../context';
import './Llm.scss'
import '../Utility/display.scss'
import '../Utility/positions.scss'
import '../Utility/size.scss'
import '../Utility/screenreader.scss'
import { clickOutside } from "../directives";
const selectedModel = "llama3.3-70b";
export default function Llm() {
    const [input, setInput] = createSignal("");
    const [loading, setLoading] = createSignal(false);
    const { messages, setMessages, userMessages, setUserMessages, toggleChatbox } = useStateContext();
    const sendMessage = async () => {
        if (!input().trim()) return;
        const userMessage = { role: 'user', content: input() };
        setMessages(messages().concat(userMessage));
        setUserMessages(userMessages().concat(userMessage));
        setInput('');
        setLoading(true);

        try {
            const resp = await fetch('/api/llmchat', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify({ model: selectedModel, messages: [...messages(), userMessage] })
            });
            if (!resp.ok) throw new Error('Failed to send message to the LLM');
            const data = await resp.json();
            const botMessage = { role: 'assistant', content: data.choices[0].message.content };
            setLoading(false);
            setMessages(messages().concat(botMessage));
            setUserMessages(userMessages().concat(botMessage));
        } catch (e) {
            console.error('Error communicating with the LLM:', e);
        };
    };
    return (
        <div use:clickOutside={toggleChatbox()} class="llm flex">
            <div class="chat-window">
                <div class="messages">
                    <For each={userMessages()}>
                        {(message: { role: string, content: string }) => (
                            <div
                                class={`message ${message.role === 'user' ? 'user' : 'assistant'}`}
                            >
                                {message.content}
                            </div>
                        )}
                    </For>
                    <Show when={loading()}>
                        <div class="message assistant">
                            <span class="dot"></span>
                            <span class="dot"></span>
                            <span class="dot"></span>
                        </div>
                     </Show>
                </div>
                <div class="input-bar">
                    <input
                        type="text"
                        value={input()}
                        onInput={(e) => setInput(e.target.value)}
                        placeholder="Type your message..."
                        onKeyDown={(e) => e.key === 'Enter' && sendMessage()}
                        disabled={loading()}
                    />
                    <button onClick={sendMessage} disabled={loading()}>
                        {loading() ? 'Sending...' : 'Send'}
                    </button>
                </div>
            </div>
        </div>
    );
}
